import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('issuer_disclaimer', '/issuer_disclaimers')
const reducer = generator.generate()

export default reducer
